import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { styled } from "baseui";
import { useHistory, useLocation } from "react-router-dom";
import ROUTES_PATH from "../../constants/RouteConstants";
import SubHeader from "../../components/sub-header/SubHeader";
import ListSearchGroup from "../../components/list-search-group/ListSearchGroup";
import ListAsideView from "../../components/list-aside-view/ListAsideView";
import ListSidebarView from "../../components/list-sidebar/ListSidebarView";
import { ACCESS_TYPES, MODELERS_SIDEBAR_ITEMS, RESOURCE_TYPES } from "../../constants/AppEnums";
import * as AppConstants from "../../constants/AppConstants";
import PaginatedSearchList from "../../components/paginated-search-list/PaginatedSearchList";
import { fetchProducts } from "../../redux/template/TemplateThunk";
import { useListSearchFilters } from "../../hooks/useListSearchFilters";
import { useFetchItemsList } from "../../hooks/useFetchItemsList";
import { Grid, Cell } from "baseui/layout-grid";
import * as TemplateActions from "../../redux/template/TemplateActions";
import * as GLOBAL_CONSTANTS from "../../constants/GlobalConstants";
import useToaster from "../../hooks/useToaster";
import { resetModelRunState } from "../../redux/model-run/ModelRunActions";
import { createProductCheckoutSession } from "../../helpers/PaymentHelpers";
import PremiumLock from "../../components/premium-lock/PremiumLockComponent";
const MainContainer = styled(Grid, ({ $theme }) => ({
  margin: "50px",
  padding: AppConstants.APP_MAIN_PADDING,
  overflowY: "scroll",
}));

const SidebarArea = styled(Cell, ({ $theme }) => ({
  borderRight: "2px solid",
}));

function ProductListView(props) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(true);
  const [products, setProducts] = useState(props.productsList);
  const [buyIsLoading, setBuyIsLoading] = useState({});
  
  useToaster(props.searchErrorMessage);
  useToaster(props.cloneErrorMessage);
  const {
    viewMode,
    setViewMode,
    setFilterQuery,
    setSearchQuery,
    currentPage,
    setCurrentPage,
    numPages,
  } = useListSearchFilters("list", props.totalProducts);

  const { retryFetch } = useFetchItemsList(currentPage, fetchProducts);

  useEffect(() => {
    setIsLoading(props.isLoadingSearch);
  }, [props.isLoadingSearch, props.searchError, props.searchErrorMessage]);

  useEffect(() => {
    setProducts(props.productsList);
  }, [props.productsList]);

  const  handleBuyProduct = async (productId) => {
    setBuyIsLoading(prev => ({ ...prev, [productId]: true }));
    try {
      let res = await createProductCheckoutSession(productId);
      if (res) {
        window.location.href = res;
      }
    } catch (error) {
      console.error("Failed to create checkout session:", error);
    } finally {
      setBuyIsLoading(prev => ({ ...prev, [productId]: false }));
    }

  }

  return (
    <Fragment>
      {/* <CloneModal
        onClose={() => {
          props.resetErrors();
          setIsCreateModalOpen(false);
        }}
        isOpen={isCreateModalOpen}
        headerTitle={"Clone Product"}
        onClone={(newTitle, access) => onModalCreateClick(newTitle, access)}
        cloningInProgress={cloningInProgress}
      /> */}
      <SubHeader
        centerChildren={
          <ListSearchGroup
            onTimeKeywordSearchChange={setSearchQuery}
            onRetryFetch={retryFetch}
            onViewModeChange={setViewMode}
          />
        }
      ></SubHeader>
      <MainContainer>
      <Cell span={[1, 2, 2.5]}>      
        </Cell>
        <Cell span={[2, 4, 7]}>
          <PaginatedSearchList
            resourceType={RESOURCE_TYPES.PRODUCT}
            isLoading={isLoading}
            retryFetch={retryFetch}
            items={products}
            viewMode={viewMode}
            error={props.searchError}
            errorMessage={props.searchErrorMessage}
            onBuyItem={(id) => handleBuyProduct(id)}
            itemIsLoading={buyIsLoading}
            onPageChange={(page) => setCurrentPage(page)}
            currentPage={currentPage}
            numPages={numPages}
          />
        </Cell>
        <Cell span={[1, 2, 2.5]}>
          <ListAsideView
            onFilterSelectChange={setFilterQuery}
          ></ListAsideView>
        </Cell>
      </MainContainer>
    </Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user.username,
    userId: state.user.id,
    productsList: state.template.productsList,
    isLoadingSearch: state.template.isLoadingProductsSearch,
    totalProducts: state.template.totalProducts,
    searchError: state.template.searchErrorProducts,
    searchErrorMessage: state.template.searchErrorMessageProducts,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFectchProducts: () => {
      dispatch(fetchProducts());
    },
    onFectchProductsByUser: (createdBy) => {
      dispatch(
        fetchProducts({
          access: { eq: ACCESS_TYPES.PUBLIC },
          createdBy: { eq: createdBy },
        })
      );
    },
    // onSetactiveProduct: (item) => {
    //   dispatch(setactiveProduct(item));
    // },
    // onCloneProduct: (user, modelerId, modelerTitle, access) => {
    //   dispatch(cloneProduct({ user, modelerId, modelerTitle, access }));
    // },
    // resetErrors: () => {
    //   dispatch(ProductActions.resetErrors());
    // },
    resetModelRunState: () => {
      dispatch(resetModelRunState());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductListView);
